/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOOffBoardingHistory from "./DTOOffBoardingHistory";
import OffBoardingHistoryPresenter from "./OffBoardingHistoryPresenter";
import { useTranslation } from "react-i18next";

function OffBoardingHistoryController() {
  const [offboardingWithdrawnData, setOffboardingWithdrawnData] = useState({});
  const [offboardingData, setOffboardingData] = useState({});
  const { t } = useTranslation();

  function getDataWithdrawn(data: any) {
    setOffboardingWithdrawnData(data);
  }

  function getData(data: any) {
    setOffboardingData(data);
  }

  return (
    <>
      <DTOOffBoardingHistory
        setOffboardingWithdrawnData={getDataWithdrawn}
        setOffboardingData={getData}
      />
      <OffBoardingHistoryPresenter
        offboardingWithdrawnData={offboardingWithdrawnData}
        offboardingData={offboardingData}
        trans={t}
      />
    </>
  );
}

export default OffBoardingHistoryController;
